import React from "react";

export const tableHeaderStyles: React.CSSProperties[] = [
  {
    backgroundColor: "#F4F4F5",
    padding: "10px",
    minWidth: "100px",
    height: "48px",
  },
  {
    backgroundColor: "#F4F4F5",
    padding: "10px",
    minWidth: "100px",
    height: "48px",
  },
  {
    backgroundColor: "#F4F4F5",
    padding: "10px",
    minWidth: "100px",
    height: "48px",
  },
  {
    backgroundColor: "#F4F4F5",
    padding: "10px",
    minWidth: "100px",
    height: "48px",
  },
  {
    backgroundColor: "#F4F4F5",
    padding: "10px",
    minWidth: "100px",
    height: "48px",
  },
];

export const tableCellStyles: React.CSSProperties[] = [
  {
    padding: "10px",
    minWidth: "100px",
    height: "52px",
  },
  {
    color: "#3F3F46",
    padding: "10px",
    minWidth: "100px",
    height: "52px",
  },
  {
    color: "#3F3F46",
    padding: "10px",
    minWidth: "100px",
    height: "52px",
  },
  {
    color: "#3F3F46",
    padding: "10px",
    minWidth: "100px",
    height: "52px",
  },
  {
    color: "#3F3F46",
    padding: "10px",
    minWidth: "100px",
    height: "52px",
  },
];
